import { init, RematchRootState, RematchDispatch } from '@rematch/core';
import immerPlugin from './rematch_immer';
// import { captcha} from './index';
import { captcha } from './collect';

const models = {
  captcha: captcha,
};
type models = typeof models;
const immer = immerPlugin();

export default function configure() {
  const store = init({
    models,
    plugins: [immer],
  });
  return store;
}

export type RootState = RematchRootState<models>;
export type RootDispatch = RematchDispatch<models>;
